import { useRef, useState } from "react";
import { components } from "react-select";

import { Button, SVGSprite } from "@/components/Atoms";
import SelectInput from "@/components/Atoms/Inputs/SelectInput";
import CheckboxInput from "@/components/Atoms/Inputs/CheckboxInput";
import Typography from "@/foundation/Typography/V2";

import { classNameGenerator, clsx } from "@/utils";

import styles from "./FilterInput.module.scss";

interface FilterInputProps {
  className?: string;
  placeholder?: string;
  menuItemDescription?: string;
  selectedItemText: string;
  name: string;
  options: any;
  value: any[];
  onChange: (value: any[]) => void;
  onSubmit: (value: any[]) => void;
}

const FilterInput: React.FC<FilterInputProps> = ({
  className,
  placeholder,
  selectedItemText,
  value,
  onChange,
  onSubmit,
  ...rest
}) => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const inputRef = useRef(null);

  const cls = classNameGenerator(styles);

  const CustomMenu = ({ children, ...props }) => (
    <components.Menu {...props}>
      <Typography variant="paragraph1" className={cls("menuItemDescription")}>
        {placeholder}
      </Typography>
      {children}
      <Button
        className={cls("submitButton")}
        onClick={() => {
          onSubmit(value);
          setMenuOpen(false);
        }}
      >
        Confirm
      </Button>
    </components.Menu>
  );

  const CustomOption = ({ children, ...props }) => (
    <components.Option {...props}>
      <div className={cls("optionContainer")}>
        <CheckboxInput value={props.isSelected} />
        <div className={cls("label")}>{children}</div>
      </div>
    </components.Option>
  );

  const CustomValueContainer = ({ children, ...props }) => (
    <components.ValueContainer {...props}>
      {value?.length ? (
        <div className={cls("valueContainer")}>
          <SVGSprite icon="icon-check-success" className={cls("icon")} />
          <div className={cls("label")}>{selectedItemText}</div>
        </div>
      ) : (
        <div className={cls("valueContainer")}>{children}</div>
      )}
    </components.ValueContainer>
  );

  return (
    <div ref={inputRef}>
      <SelectInput
        className={clsx(cls("filterInput"), className)}
        value={value}
        isMulti
        hideSelectedOptions={false}
        isClearable={false}
        isSearchable={false}
        menuIsOpen={isMenuOpen}
        onMenuOpen={() => setMenuOpen(true)}
        onMenuClose={() => setMenuOpen(false)}
        components={{
          Menu: CustomMenu,
          Option: CustomOption,
          ValueContainer: CustomValueContainer,
        }}
        onChange={onChange}
        placeholder={placeholder}
        closeMenuOnSelect={false}
        blurInputOnSelect={false}
        {...rest}
      />
    </div>
  );
};

export default FilterInput;
